export default [{
    title: 'Maestros de Datos',
    icon: 'DatabaseIcon',
    route: 'master-data-index',
    action: 'manage',
    resource: 'master-data'
}];
